import { Injectable, Output, EventEmitter } from "@angular/core";
import { HttpClient, HttpEventType } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { MediaResultModel } from "../models/MediaResultModel";
import { ToastrService } from "ngx-toastr";
import { NgxUiLoaderService } from "ngx-ui-loader"
import { Value } from "../models/BingImageResult";
import { Observable } from "rxjs";
import { TutorialVideo } from "../engine/models/models";

@Injectable({
  providedIn: "root"
})
export class MediaService {
  public progress: number;

  @Output() public onUploadFinished = new EventEmitter<MediaResultModel>();

  constructor(private http: HttpClient, private toastr: ToastrService, private ngxuiloaderService: NgxUiLoaderService) { }

  getTutorialVideos() {
    return this.http.get<TutorialVideo[]>(`${environment.api}/api/video`);
  }
  getMediaById(id: number) {
    return this.http.get<MediaResultModel>(`${environment.api}/media?id=${id}`);
  }

  uploadFile(file: File) {
    const formData = new FormData();

    formData.append('picture', file, file.name);

    this.http.post<MediaResultModel>(`${environment.api}/media`, formData, { reportProgress: true, observe: 'events' })
      .subscribe(event => {
        if (event.type === HttpEventType.UploadProgress)
          this.progress = Math.round(100 * event.loaded / event.total);
        else if (event.type === HttpEventType.Response) {
          if (event.body && event.body.isValid) {
            //this.toastr.success(`Picture has been uploaded successfully.`, "Success");
            this.onUploadFinished.emit(event.body);
            this.ngxuiloaderService.stop();
          }
          else {
            this.toastr.warning(event.body.validationMessage, "Warning");
            //this.globals.isUploading = false;
            this.ngxuiloaderService.stop();
          }
        }
      });
  }

  getMediaAssociations(optionId?: number): Observable<Value[]> {
    if (optionId) {
      return this.http.get<Value[]>(`${environment.api}/api/MediaAssociation?optionId=${optionId}`);
    }
    return this.http.get<Value[]>(`${environment.api}/api/MediaAssociation`);
  }

  createMediaAssociation(association: Value): Observable<boolean> {
    return this.http.post<boolean>(`${environment.api}/api/MediaAssociation`, association);
  }

  removeMediaAssociation(association: Value): Observable<boolean> {
    return this.http.delete<boolean>(`${environment.api}/api/MediaAssociation?optionId=${association.optionId}&imageId=${association.imageId}`);
  }

  updateMediaAssociation(association: Value): Observable<boolean> {
    return this.http.put<boolean>(`${environment.api}/api/MediaAssociation`, association);
  }
}
